import { api2 , apiNoCre} from './ApiService';

const  baseURL = process.env.API

export default class AuthService {
    static async checkToken(token){
        let response = await api2.get(`/auth/check/token/${token}`)
        return response.data
    }

    static async login(username,password){
        let response =  await apiNoCre.post(`/auth`, {username : username,password : password, type : 'user'})
        return response.data
    }

    static async refreshToken() {
        let refreshToken = localStorage.getItem('refresh_token');
       const response = await api2.post(`/auth/refresh/${refreshToken}`);
      
       localStorage.setItem('token', response.data.token);
        
    }
 
}


// WEBPACK FOOTER //
// ./src/service/AuthService.js